import React from 'react'
import { Link } from 'react-router-dom'
import { Code2, Mail, Linkedin, MapPin } from 'lucide-react'
import { motion } from 'framer-motion'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-base-200/50 border-t border-base-300 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Brand Section */}
          <div>
            <Link to="/" className="flex items-center space-x-2 mb-4 group">
              <motion.div
                whileHover={{ rotate: 360 }}
                transition={{ duration: 0.5 }}
              >
                <Code2 className="w-8 h-8 text-primary" />
              </motion.div>
              <span className="text-xl font-bold text-gradient use-my-font">Jarrad Totman</span>
            </Link>
            <p className="text-base-content/70 mb-4">
              Senior Developer, Technical Director, and Full-Stack Engineer with 16+ years of experience in game development, web technologies, and cutting-edge solutions.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://linkedin.com/in/jarradtotman"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg hover:bg-base-300 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="mailto:jarradtotman@gmail.com"
                className="p-2 rounded-lg hover:bg-base-300 transition-colors"
                aria-label="Email"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-primary">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <a
                  href="mailto:jarradtotman@gmail.com"
                  className="text-base-content/70 hover:text-primary transition-colors"
                >
                  jarradtotman@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-base-content/70">Available for remote work worldwide</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-base-300 mt-8 pt-8 text-center">
          <p className="text-base-content/60 text-sm">
            &copy; {currentYear} Jarrad Totman. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
